/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExtractionToken } from './ExtractionToken.js';
import {
    ExtractionTokenFromJSON,
    ExtractionTokenFromJSONTyped,
    ExtractionTokenToJSON,
} from './ExtractionToken.js';
import type { NamedEntity } from './NamedEntity.js';
import {
    NamedEntityFromJSON,
    NamedEntityFromJSONTyped,
    NamedEntityToJSON,
} from './NamedEntity.js';

/**
 * 
 * @export
 * @interface ExtractionResponse
 */
export interface ExtractionResponse {
    /**
     * 
     * @type {string}
     * @memberof ExtractionResponse
     */
    text?: string;
    /**
     * 
     * @type {Array<NamedEntity>}
     * @memberof ExtractionResponse
     */
    entities?: Array<NamedEntity>;
    /**
     * 
     * @type {Array<ExtractionToken>}
     * @memberof ExtractionResponse
     */
    tokens?: Array<ExtractionToken>;
}

/**
 * Check if a given object implements the ExtractionResponse interface.
 */
export function instanceOfExtractionResponse(value: object): boolean {
    return true;
}

export function ExtractionResponseFromJSON(json: any): ExtractionResponse {
    return ExtractionResponseFromJSONTyped(json, false);
}

export function ExtractionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'entities': json['entities'] == null ? undefined : ((json['entities'] as Array<any>).map(NamedEntityFromJSON)),
        'tokens': json['tokens'] == null ? undefined : ((json['tokens'] as Array<any>).map(ExtractionTokenFromJSON)),
    };
}

export function ExtractionResponseToJSON(value?: ExtractionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
        'entities': value['entities'] == null ? undefined : ((value['entities'] as Array<any>).map(NamedEntityToJSON)),
        'tokens': value['tokens'] == null ? undefined : ((value['tokens'] as Array<any>).map(ExtractionTokenToJSON)),
    };
}

